export default __webpack_public_path__ + "static/media/contact.5a44f252.jpg";